import { Component, inject } from '@angular/core';
import { SaleTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SaleTypeCreateDto,
  SaleTypeDto,
  SaleTypeExcelDownloadDto,
  SaleTypeUpdateDto,
} from '../proxy/controlling/dtos/sale-type';
import { SALETYPE_CONFIG, SALETYPE_FIELDS } from './sale-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sale-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SaleTypeService, ConfirmationService],
  templateUrl: './sale-type.html',
  styleUrl: './sale-type.scss',
})
export class SaleType extends BaseCrudComponent<
  SaleTypeDto,
  SaleTypeCreateDto,
  SaleTypeUpdateDto,
  SaleTypeExcelDownloadDto
> {
  service = inject(SaleTypeService);
  config = SALETYPE_CONFIG;
  fields = SALETYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SaleTypeDto): SaleTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SaleType';
  }
}
